export default "<ion-app mode=\"ios\">\r\n  <ion-router-outlet></ion-router-outlet>\r\n</ion-app>\r\n";